<div
  class="tile"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <ion-card
    id="{{ id }}"
    [class.delivered]="isDelivered"
    [class.eta]="!isDelivered"
    [class.white-title]="backgroundImage"
    [class.lists-mobile]="isMobile && lists?.length"
    [style.background-image]="backgroundImage"
    [class.remove-padding]="type === 'recommended'"
    (click)="
      isDesktop || type === 'lists' || (type === 'recommended' && !isMobile)
        ? null
        : routeTo(path)
    "
  >
    <!-- TITLE -->
    <h2
      *ngIf="title && type !== 'news'"
      [class.small-text-title]="type === 'recommended'"
    >
      {{ title | translate }}
    </h2>

    <h2 *ngIf="!title && type === 'news'">{{ newsTitle }}</h2>
    <!-- BODY -->
    <p *ngIf="!isMobile && textBody && type !== 'lists' && type !== 'news'">
      {{ textBody | translate }}
    </p>
    <p *ngIf="!isMobile && !textBody && type === 'news'">
      {{ newsBody }}
    </p>
    <p
      *ngIf="
        !isMobile && textBody && type === 'lists' && listsData?.isListDataLoaded
      "
    >
      {{ textBody | translate }}
    </p>
    <div *ngIf="type === 'wmt' && !hideEtaRange" class="tile-wmt">
      <p data-cy="home-wmt-description-text" class="grid-area-text">
        {{ dtDescription | translate }}
      </p>
      <p data-cy="home-wmt-delivery-date-text" class="wmt-eta-date">
        {{ deliveryDate }}
      </p>
      <p data-cy="home-wmt-delivery-time-text" class="wmt-eta-time">
        {{ deliveryTime }}
        <ion-icon
          *ngIf="etaReasonShort?.trim() || etaReasonLong?.trim()"
          name="alert"
          class="alert-icon"
        ></ion-icon>
      </p>
    </div>
    <div *ngIf="type === 'wmt' && hideEtaRange" class="tile-wmt">
      <p data-cy="home-wmt-description-text" class="grid-area-text">
        <ng-container *ngIf="isMobile; else desktopEtaTitle">
          {{ 'i18n.home.wmtTile.etaMobile' | translate }}
        </ng-container>
        <ng-template #desktopEtaTitle>
          {{ 'i18n.home.wmtTile.eta' | translate }}
        </ng-template>
      </p>
      <p data-cy="home-wmt-delivery-date-text" class="wmt-eta-date">
        <ng-container *ngIf="isMobile; else desktopEta">
          {{ confirmedDeliveryDate | date: 'MM/dd' : 'GMT' }}
        </ng-container>
        <ng-template #desktopEta>
          {{ confirmedDeliveryDate | date: 'M/d/yyyy' : 'GMT' }}
        </ng-template>
        <ion-icon
          *ngIf="etaReasonShort?.trim() || etaReasonLong?.trim()"
          name="alert"
          class="alert-icon"
        ></ion-icon>
      </p>
    </div>
    <div
      *ngIf="type === 'betterBuys' && totalAnnualSavings > 0 && !isMobile"
      class="better-buys-desktop-tablet"
    >
      <p class="you-can-save bold">
        {{ 'i18n.home.betterBuysTile.youCanSave' | translate }}
      </p>
      <p
        class="savings"
        [class.tablet-savings]="
          platformService.platformType === platformService.platformEnum.tablet
        "
      >
        {{ totalAnnualSavings | currency }}
      </p>
      <p class="annually-by-swapping bold">
        {{ 'i18n.home.betterBuysTile.swappingProducts' | translate }}
      </p>
    </div>
    <div *ngIf="type === 'recommended'" class="tile-recommended">
      <div *ngIf="!isMobile" class="recommended-desktop-tablet">
        <p
          *ngIf="recommendedContent"
          class="recommended-unread"
          data-cy="home-tm-note-desktop-unread-count-text"
        >
          {{
            recommendedContent.unreadCount
              ? recommendedContent.unreadCount +
                ('i18n.home.recommendedTile.unread' | translate)
              : ''
          }}
        </p>
        <div
          data-cy="home-tm-note-desktop-details-link-div"
          class="recommended-tmn"
          (click)="routeTo([recommendedContent.noteId])"
        >
          <p
            class="recommended-title"
            data-cy="home-tm-note-desktop-title-text"
          >
            {{ recommendedContent.recommendedTitle }}
          </p>
          <p class="recommended-date" data-cy="home-tm-note-desktop-date-text">
            {{ recommendedContent.recommendedDate | date: 'MM/dd/yyyy' : 'Z' }}
          </p>
          <p
            class="recommended-description"
            data-cy="home-tm-note-desktop-description-text"
          >
            {{ recommendedContent.recommendedDescription }}
          </p>
        </div>
      </div>
      <ion-badge
        data-cy="home-tm-note-mobile-unread-count-badge"
        *ngIf="isMobile && recommendedContent"
        class="recommended-counter"
        color="success"
      >
        {{ recommendedContent.unreadCount }}</ion-badge
      >
    </div>

    <!-- BUTTONS -->
    <div
      *ngIf="type === 'lists' && lists?.length && listsData?.isListDataLoaded"
      class="tile-lists"
    >
      <ng-container *ngIf="!isMobile; else mobileListButton">
        <ion-button
          *ngFor="let list of lists; let i = index"
          id="home-lists-btn-{{ i }}"
          data-cy="home-lists-btn"
          class="usf-outline-green-dsktp-tblt-modal-button list-btn"
          (click)="
            openListDetails(
              list?.listKey?.listTypeId + '-' + list?.listKey?.listId,
              list?.listName
            )
          "
        >
          <span>
            {{
              list?.listKey?.listTypeId === 'OG'
                ? ('i18n.lists.orderGuide' | translate) +
                  ' #' +
                  list?.listKey?.listId
                : list?.listName
            }}
          </span>
        </ion-button>
      </ng-container>
      <ng-template #mobileListButton>
        <span
          id="home-lists-btn-mobile"
          data-cy="home-lists-btn"
          (click)="
            openListDetails(
              lists[0]?.listKey?.listTypeId + '-' + lists[0].listKey?.listId,
              lists[0]?.listName
            )
          "
        >
          {{
            lists[0]?.listKey?.listTypeId === 'OG'
              ? ('i18n.lists.orderGuide' | translate) +
                ' #' +
                lists[0]?.listKey?.listId
              : lists[0]?.listName
          }}
        </span>
      </ng-template>
    </div>

    <div
      *ngIf="
        (!isMobile && type !== 'news' && !isMobile && type !== 'lists') ||
        (!isMobile && type === 'lists' && listsData?.isListDataLoaded) ||
        (type === 'lists' && listsData?.isListDataLoaded && !lists.length)
      "
    >
      <ion-button
        [attr.data-cy]="'home-' + type + '-tile-btn'"
        [ngClass]="
          !isMobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-button'
        "
        (click)="
          type === 'lists' && listsData?.isListDataLoaded && !lists.length
            ? openCreateListModal(listsData)
            : routeTo(path)
        "
      >
        {{ textButton | translate }}
      </ion-button>
    </div>

    <div *ngIf="!isMobile && type === 'news' && newsUrl?.length">
      <ion-button
        [attr.data-cy]="'home-' + type + '-tile-btn'"
        [ngClass]="
          !isMobile
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-button'
        "
        (click)="routeTo()"
      >
        {{ newsButton }}
      </ion-button>
    </div>
  </ion-card>
</div>
